import React, { Component, useState } from 'react';
import { Link } from 'react-router-dom';

const slide = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]
export default function SignUp() {
	const [inputs, setInputs] = useState({});


	const handleChange = (e) => {
		const name = e.target.name;
		const value = e.target.value;
		setInputs({ inputs: { ...inputs, [name]: value } })

	}

	const submit = (e) => {
		e.preventDefault()


	}



	return (
		<div className="auth">
			<div className="auth_left">
				<div className="card">
					<div className="text-center mb-5">
						<Link className="header-brand" to="/">
							{/* <i className="fe fe-command brand-logo" /> */}
							<img src='assets/images/pebble-hrm-logo.svg' width={150} />
						</Link>
					</div>
					<div className="card-body">
						<div className="card-title">Create new account</div>
						<form onSubmit={submit}>
							<div className="form-group">
								<label className="form-label">Name</label>
								<input type="text" className="form-control" placeholder="Enter name" name="name" value={inputs.name || ""}
									onChange={handleChange} />
							</div>
							<div className="form-group">
								<label className="form-label">Email address</label>
								<input type="email" className="form-control" placeholder="Enter email" name="email" value={inputs.email || ""}
									onChange={handleChange} />
							</div>
							<div className="form-group">
								<label className="form-label">Password</label>
								<input type="password" className="form-control" placeholder="Password" name="password" value={inputs.password || ""}
									onChange={handleChange} />
							</div>
							<div className="form-group">
								<label className="custom-control custom-checkbox">
									<input type="checkbox" className="custom-control-input" />
									<span className="custom-control-label">
										Agree the <a href="/#">terms and policy</a>
									</span>
								</label>
							</div>
							<div className="form-footer">
								<button className="btn btn-primary btn-block" type='submit'>
									Click new account
								</button>
							</div>
						</form>
					</div>
					<div className="text-center text-muted">
						Already have account? <Link to="/login">Sign In</Link>
					</div>
				</div>
			</div>
			<div className="auth_right">
				<div className="carousel slide" data-ride="carousel" data-interval={3000}>
					<div className="carousel-inner">
						{slide.map((s) => {
							return (
								<div className={"carousel-item " + (s == 1 ? 'active' : null)}>
									<img src={`assets/images/brochures/c${s}.jpeg`} className="img-fluid" alt="login page" />
									<div className="px-4 mt-4">
										{/* <h4>{i}</h4>
											<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</p> */}
									</div>
								</div>
							)
						})}
						{/* <div className="carousel-item active">
								<img src="assets/images/slider1.svg" className="img-fluid" alt="login page" />
								<div className="px-4 mt-4">
									<h4>Fully Responsive</h4>
									<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</p>
								</div>
							</div>
							<div className="carousel-item">
								<img src="assets/images/slider2.svg" className="img-fluid" alt="login page" />
								<div className="px-4 mt-4">
									<h4>Quality Code and Easy Customizability</h4>
									<p>There are many variations of passages of Lorem Ipsum available.</p>
								</div>
							</div>
							<div className="carousel-item">
								<img src="assets/images/slider3.svg" className="img-fluid" alt="login page" />
								<div className="px-4 mt-4">
									<h4>Cross Browser Compatibility</h4>
									<p>Overview We're a group of women who want to learn JavaScript.</p>
								</div>
							</div> */}
					</div>
				</div>
			</div>
		</div>
	);

}
